import { COLORS } from '@btime/constants'
import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

const TransportSection = () => (
  <View id="10">
    <Text bold size="small">
      10. LEVANTAMENTO, TRANSPORTE, DESCARGA E MOVIMENTOS REPETITIVOS INDIVIDUAL DE MATERIAL
    </Text>

    <Separator weight={8} />

    <Text bold size="small">
      10.1 LEVANTAMENTO E TRANSPORTE DE CARGA
    </Text>

    <Separator weight={4} />

    <Text>
      Transporte manual de cargas designa todo transporte no qual o peso da carga é suportado inteiramente por um só
      trabalhador, compreendendo o levantamento e disposição da carga. Transporte manual regular de cargas designa toda
      atividade realizada de maneira contínua ou que inclua, mesmo de forma descontínua, o transporte manual de cargas.
      <br />
      Nos casos em que o levantamento e a movimentação manual não forem possíveis de serem evitados, será realizada a
      avaliação de riscos à saúde e à segurança, considerando a massa do objeto, a pega usada para manuseio, o controle
      do objeto em relação à posição do corpo, a frequência e a duração de uma tarefa específica. Adequando a tarefa nas
      análises ergonômicas de acordo com a NBR11. 228-1 de 2017, com pesos a serem movimentados acima de 5kg em
      frequência diária de atividade. Para todos os trabalhadores o peso de movimentação máxima, não deve exceder os
      15kg para qualquer tipo de peso a ser movimentado por dia.
    </Text>

    <Separator weight={8} />

    <Text bold size="small">
      Conclusão/ Ação de Ergonomia:
    </Text>

    <Separator weight={4} />

    <ul>
      <li>
        <Text>Não foram encontrados trabalhos com carregamento e transporte de cargas.</Text>
      </li>
    </ul>

    <Separator weight={8} />

    <Text bold size="small">
      10.2 EMPURRAR E PUXAR CARGA
    </Text>

    <Separator weight={4} />

    <Text>
      Empurrar e puxar, como definição são todas as forças usadas por um só trabalhador na execução de tarefas de
      movimentação ou contensão de um objeto ou peso utilizando esforço físico humano quando há força motriz em relação
      ao movimento de carga, nas tarefas de empurrar ou puxar, analisando as diversas forças aplicadas no manuseio
      humano.
      <br /> Nos casos que envolvam atividades/tarefas de empurrar ou puxar carga, onde não forem possíveis de serem
      evitados, convêm que seja feito uma avaliação dos riscos à saúde e à segurança no ambiente, atividades, projetos e
      frequência. Adequando as tarefas de acordo com a NRB11228-2 DE 2017, com o objetivo de melhorias no ambiente de
      trabalho, nos projetos e de atividades, equipamentos necessários e organização de trabalho.
    </Text>

    <Separator weight={8} />

    <Text bold size="small">
      Conclusão/ Ação de Ergonomia:
    </Text>

    <Separator weight={4} />

    <ul>
      <li>
        <Text>Não foram encontrados trabalhos com carregamento e transporte de cargas.</Text>
      </li>
    </ul>

    <Separator weight={8} />

    <Text bold size="small">
      10.3 MOVIMENTO DE CARGAS LEVES EM ALTA FREQUÊNCIA DE REPETITIVIDADE
    </Text>

    <Separator weight={4} />

    <Text>
      Os fatores de risco com trabalhos em que haja repetitividade devem ser analisados em relação à frequência das
      ações, duração da tarefa, postura e movimentos dos segmentos do corpo, organização do trabalho, controle das
      tarefas, treinamentos e fatores complementares ambientais como a temperatura, ruído, vibração, iluminamentos.
      <br />
      As recomendações evidenciadas na NBR11.228-3 de 2014, são baseadas em evidências científica relacionada à
      fisiologia e à epidemiologia do trabalho como movimentos repetitivos. Está normativa fornece orientações sobre a
      identificação e avaliação de fatores de risco comumente associados à movimentação de cargas leves em alta
      frequência.
    </Text>

    <Separator weight={8} />

    <Text bold size="small">
      10.3.1 ANÁLISE DAS ATIVIDADES GHE1 / GHE 2 (Tabela 1) – VIDE ANEXOS
    </Text>

    <Separator weight={4} />

    <Text>
      O primeiro passo da avaliação de risco é identificar se existem riscos que possam expor indivíduos a um risco de
      lesão.
      <br />
      A estimativa de risco relacionados a movimentos repetitivos, é feita por avaliação do ambiente de trabalho dos
      funcionários Unimed. Analisando separadamente o grupo de trabalho das mesmas tarefas ou GHE's (Grupo Homogêneo de
      Exposição).
      <br />
      Para esta análise de acordo com o método 1 da NBR11.228-3 de 2017, item 4.2.3, para esta análise serão divididas
      as tarefas em quatro partes, para avaliação:
    </Text>

    <ul>
      <li>
        <Text>
          Informações preliminares realizadas no PGR descrevendo as tarefas do trabalho através da Análise Ergonômica
          Preliminar (AEP) em consonância com o item 17.3.1;
        </Text>
      </li>
      <li>
        <Text>Aprofundamento dos possíveis riscos e as características do trabalho encontrados no PGR;</Text>
      </li>
      <li>
        <Text>Avaliação geral do risco;</Text>
      </li>
      <li>
        <Text>Ação corretiva em possível exposição ao risco com movimentos repetitivos.</Text>
      </li>
    </ul>

    <Text>
      Para estimativa de risco usando o Método 1 em relação a exposição ao risco, este será classificado conforme as
      três zonas (verde, amarelo e vermelho) para que seja tomado as decisões e ações necessárias para melhoria e
      procedimentos em relação ao risco.
      <br />
      As três zonas de risco são definidas como:
    </Text>

    <ul>
      <li>
        <Text style={{ background: COLORS.lightGreen }} inline>
          a) Zona Verde (Risco Aceitável)
        </Text>

        <Text>
          O risco de doença ou lesão é insignificante ou está em nível relativamente baixo para a população de
          trabalhadores de acordo com seu GHE. Nenhuma ação é necessária.
        </Text>
      </li>

      <li>
        <Text style={{ background: COLORS.yellow }} inline>
          b) Zona Amarela (risco aceitável condicionalmente)
        </Text>

        <Text>
          Há um risco de doença ou lesão que pode ser prejudicial à população de trabalhadores ou GHE. Para que este
          risco seja melhor identificado ou quantificado de ser aplicado o próximo Método 2 da NR11.228-3 de 2017 item
          4.2.3.2, onde este poderá quantificar esta tarefa, para que seja assim feito um plano de ação corretiva.
        </Text>
      </li>

      <li>
        <Text style={{ background: COLORS.lightRed }} inline>
          c) Zona Vermelha (não aceitável)
        </Text>

        <Text>
          Há risco considerável de doença ou lesão que não pode ser negligenciado para a população de trabalhadores ou
          GHE. Uma ação corretiva imediata deve ser aplicada para reduzir o risco, efetuando um reprojeto das tarefas,
          organização do trabalho, instrução ao trabalhador e treinamento.
        </Text>
      </li>
    </ul>

    <Separator weight={4} />

    <Text>
      Este Método utilizado na avaliação dos riscos dos trabalhadores é um documento preparado pelo Comitê Técnico da
      IEA, doenças musculoesqueléticas, com o endosso da ICOH–International Commissionon Occupational Health, onde foi
      definido um modelo de aplicação geral de análise para os principais fatores de riscos a serem observados,
      apresentando procedimentos para abordagem e análise na sua descrição, classificação e avaliação.
      <br />
      Neste modelo o objetivo é analisar os quatro fatores principais de risco: repetitividade, força, posturas e
      movimentos inAdequados, e a falta de períodos de recuperação apropriados.
      <br />
      Portanto para cada tarefa executada esta deve ser classificada de acordo com o fator de risco conforme os 3 (três)
      tipo de zona. Para que assim sejam tomadas as decisões da área de saúde ocupacional da Unimed, em relação a
      prevenção e intervenções preventivas.
    </Text>

    <Separator weight={8} />

    <Text bold size="small">
      10.3.2 MÉTODO 1 –CHECK LIST DE AVALIAÇÃO DE RISCO
    </Text>

    <Separator weight={4} />

    <ul>
      <li>
        <Text>
          (B.2.1) Informações preliminares descrevendo a tarefa do trabalho
          <br />
          Consiste em informações gerais (descrição do trabalho, tarefas a serem avaliadas, etc.), ou por avaliação de
          queixas relacionadas ao trabalho ou mudanças no trabalho (organizacional, ou ambiental).
        </Text>
      </li>

      <li>
        <Text>
          (B.2.2) Identificação do perigo, procedimento de estimativa de risco e checklist
          <br />
          Esta análise apresenta um procedimento de cinco passos a serem verificados dos fatores de risco físico.
        </Text>
      </li>

      <li>
        <Text>
          (B.2.3) Avaliação Geral do Risco:
          <br />
          Esta fase analisa o método da avaliação e classifica os riscos e as ações a serem tomadas como consequência.
          Classificando assim os riscos de acordo com cada zona (Vermelho, Amarelo e Verde), sendo que se um risco for
          identificado como Vermelho o risco geral é Vermelho, caso nenhum dos riscos seja vermelho, mas um ou mais
          estiverem na zona Amarela, o risco geral é amarelo, se todos os níveis de risco estiverem na zona verde, então
          todos serão classificados como Verde.
        </Text>
      </li>

      <li>
        <Text>
          B2.4 Ação Corretiva a ser tomada
          <br />
          Ver Tabela B.2.4 para ação corretiva que convém aos possíveis riscos
        </Text>
      </li>
    </ul>

    <Text>
      Esta análise é usada para uma avaliação de risco específico, por trabalho ou tarefa em condições de repetitividade
      ou repetidos frequentemente por um período significativo do dia de trabalho normal.
      <br />
      Nota: Se a duração do trabalho repetitivo for menor que 1h/dia ou 5h/semanal, o risco causado pela repetição é
      considerado insignificante. Neste caso não é necessário fazer mais nenhuma avaliação do risco de repetitividade.
    </Text>

    <Separator weight={8} />
  </View>
)

export default TransportSection
